import { render, staticRenderFns } from "./GjwListPageLayout.vue?vue&type=template&id=6398fa91&scoped=true&"
import script from "./GjwListPageLayout.vue?vue&type=script&lang=js&"
export * from "./GjwListPageLayout.vue?vue&type=script&lang=js&"
import style0 from "./GjwListPageLayout.vue?vue&type=style&index=0&id=6398fa91&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6398fa91",
  null
  
)

export default component.exports